import { Col } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { UserJobSwiper } from "../../../../../../data/pages/Other";
import { useAppSelector } from "../../../../../../reduxToolkit/hooks";
import JobProductBox2 from "../../../../../commonComponents/productBox/JobProductBox2";

const JobCard = () => {
  const { productItem } = useAppSelector((state) => state.product);
  return (
    <Col xl="7">
      <Swiper className="user-job-swiper job-hire-section" {...UserJobSwiper}>
        {productItem
          .filter(({ type }) => type === "job")
          .map((job, index) => (
            <SwiperSlide key={index}>
              <JobProductBox2 data={job} />
            </SwiperSlide>
          ))}
      </Swiper>
    </Col>
  );
};

export default JobCard;
